import React from 'react';
import { PublicQuestionsType } from 'types/course.type';
import QuestionCard from 'components/Consulting/questionCard';

const SingleQuestion: React.FC<{ data: PublicQuestionsType }> = ({ data }) => {
  return (
    <div className="bg-black10 p-[40px] pt-[80px] md:pt-[40px] min-h-screen md:min-h-[calc(100vh-114px)]">
      <QuestionCard question={data} />
    </div>
  );
};

export default SingleQuestion;
